import { Observable } from 'rxjs';

export type DynamicBlocks = Record<string, DynamicBlock[]>;

export interface DynamicBlock<T = any> {
  variant: BlockVariant;
  orientation?: 'horizontal' | 'vertical';
  class?: string;
  props?: T;
}

export interface SingleTextBlock {
  content: string;
  class?: string;
}

export interface TextBlockProps {
  orientation?: 'horizontal' | 'vertical';
  gap: number;
  blocks: SingleTextBlock[];
  class?: string;
}

export interface ButtonBlockProps {
  label: string;
  severity?: 'primary' | 'secondary' | 'success' | 'info' | 'warn' | 'danger' | 'contrast';
  icon?: string;
  onClick: () => void;
  loading?: Observable<boolean>;
  disabled?: Observable<boolean>;
}

export interface InputTextareaBlockProps {
  class?: string;
  label: string;
  rows?: number;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  error?: Observable<string | null>;
}

export interface DropdownListBlockProps {
  class?: string;
  label: string;
  items: any[];
  renderAs: (item: any, index: number) => { type: 'TEXT' | 'LINK'; value: string; class: string; [key: string]: any };
  onClick?: (item: any, index: number) => void;
}

export interface CommentBlockProps {
  class?: string;
  label: string;
  content: string;
  date: string;
}

export interface CustomBlockProps {
  component: any;
  inputs?: Record<string, unknown>;
}

export enum BlockVariant {
  TEXT = 'text',
  BUTTON = 'button',
  INPUT_TEXTAREA = 'input_textarea',
  DROPDOWN_LIST = 'dropdown_list',
  CUSTOM = 'custom',
  INPUT_FILE = 'input_file',
  COMMENT = 'comment',
  SEPERATOR = 'seperator',
}
